import { PartnerAlimonyQuestion } from '@hb/domain/steps/financial-obligation';
import { FinancialObligationsStoreService } from '@hb/modules/financial-obligations/financial-obligations-store.service';
import { FieldSubject } from '@hb/domain/field-subject';
import { money } from '@hb/builder';
import { AbstractStoreInjectOption } from '@hb/services/store/abstract-store-inject.service';

import { inject, Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { Money } from '@ap/interface-bspc-core';

@Injectable({
    providedIn: 'root'
})
export class PartnerAlimonyStoreService extends AbstractStoreInjectOption<PartnerAlimonyQuestion> implements OnDestroy {
    protected readonly store = inject(FinancialObligationsStoreService);
    protected readonly lastQuestion = PartnerAlimonyQuestion.SUMMARY;

    private partnerAlimonySubscription: Subscription;
    private readonly amountSubject: FieldSubject<Money>;

    constructor() {
        super();
        this.init();

        const initialValues = this.getInitialValues();
        this.amountSubject = new FieldSubject<Money>(initialValues);
        this.subscriptions();
    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
        this.partnerAlimonySubscription.unsubscribe();
        this.activeQuestionSubject.unsubscribe();
        this.amountSubject.unsubscribe();
    }

    getAmount(): Money {
        return this.amountSubject.value;
    }

    setAmount(amount: string): void {
        this.amountSubject.next(money(amount));
    }

    getInitialValues(): Money {
        return this.store.getFinancialObligationState()?.partner_alimony_amount;
    }

    update(): void {
        this.store.setPartnerAlimony(this.amountSubject.value);
    }

    private subscriptions(): void {
        this.amountSubject.asObservable().subscribe(() => this.update());
        this.partnerAlimonySubscription = this.store.getFinancialObligationsOptions().subscribe((options) => {
            if (!options.partnerAlimony) {
                this.amountSubject.next(null);
            }
        });
    }
}
